import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Radio,
  Stack,
  Typography,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import { useDispatch } from "react-redux";
import {
  setExamResultsArr,
  setPendingInterviewArr,
  setIsGraded,
  setTutorPass,
  setTutorResult,
} from "../../../../../redux/slice/tutorExamSlice";
import { FidgetSpinner } from "react-loader-spinner";
import Loader from "./loader/Loader";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AnswerModal({ data, open, handleClose, setResSubmitted, resSubmitted }) {
  const [marked, setMarked] = React.useState("");
  const [totalMarks, setTotalMarks] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [secondDialogOpen, setSecondDialogOpen] = React.useState(false);
  const [meetingLink, setMeetingLink] = React.useState(""); // new state for meeting link
  const [interviewDateTime, setInterviewDateTime] = React.useState(null); // new state for date/time
  const [isMarkSectionVisible, setIsMarkSectionVisible] = React.useState(false); // state to toggle Insert Mark section
  const [tutorIntro, setTutorIntro] = React.useState(data?.introduction);

  const dispatch = useDispatch();

  const handleClickSecondOpen = (e) => {
    if (totalMarks < 0 || totalMarks > 100 || !marked) {
      alert("Please mark status and enter marks (0 to 100)");
      return;
    }
    setSecondDialogOpen(true);
  };

  const handleSecondClose = () => {
    setSecondDialogOpen(false);
  };

  const handleKeyDown = (event, val) => {
    if (event.key === "Enter") {
      event.preventDefault();
      setTotalMarks(val);
    }
  };

  const handleRadioChange = (value) => {
    setMarked(value);
  };

  const sendSubjectiveGrade = React.useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.put(
        "https://testapis4.el.r.appspot.com/api/tutorWeb/grade-interview",
        {
          doerId: data.doerId,
          interviewId: data.interviewId,
          marks: totalMarks,
          status: marked,
          meetingLink,
          interviewDateTime,
          interviewedAt: new Date(),
          introduction:tutorIntro
        }
      );
      if(marked =='pass'){
      let rating = Math.round((totalMarks / 20) * 100) / 100;
      await axios.put(`https://device20apigcp.el.r.appspot.com/v1/api/tutor/updateTutorRatingForClass/${data?.doerId}`,{
      rating:rating
    })

      await axios.put(`https://dev6apis.el.r.appspot.com/api/tutorWeb/updateTutorRatingForClass/${data?.doerId}`,{
      rating:rating
    })
  }

      if (response.status === 200 || response.status === 201) {
        alert("Result Updated");
        handleClose();
        setResSubmitted(!resSubmitted);
      }
      setLoading(false);
    } catch (error) {
      alert("Some error occurred. Please try after some time.");
      setLoading(false);
    }
  }, [handleClose, dispatch, data, totalMarks, marked, meetingLink, interviewDateTime]);

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Interview Response ({data?.interviewId})</DialogTitle>
        <DialogContent
          sx={{
            borderBottomWidth: "1px",
            padding: "0",
          }}
        >
          {/* New section for meeting link and interview date/time */}
          <Box mb={2} sx={{ borderTopWidth: "1px", padding: "15px 20px" }}>
            <Box>
              {/* <p> {data?.interviewId}</p> */}
              <label>Meeting Link</label>
              <input
                className="border border-black outline-none py-2 px-3 rounded"
                placeholder="Enter meeting link"
                value={meetingLink}
                onChange={(e) => setMeetingLink(e.target.value)}
                type="url"
              />

              <Box mt={2}>
                <label>Select Interview Date & Time</label>
                <input
                  className="border border-black outline-none py-2 px-3 rounded"
                  value={interviewDateTime || ""}
                  onChange={(e) => setInterviewDateTime(e.target.value)}
                  type="datetime-local"
                />
              </Box>
            </Box>
          </Box>
          <Box mb={2} sx={{ borderTopWidth: "1px", padding: "15px 20px" }}>
            <label>Tutor Introduction</label>
            <textarea
              className="border border-black outline-none py-2 px-3 rounded w-full resize-none"
              rows={4}
              placeholder="Enter any additional information or instructions..."
              value={tutorIntro}
              onChange={(e) => setTutorIntro(e.target.value)}
            />
        </Box>
          {/* Collapsible button to toggle Insert Mark section */}
          <Button
            variant="contained"
            onClick={() => setIsMarkSectionVisible(!isMarkSectionVisible)}
            style={{ marginBottom: "15px", marginLeft: '15px' }}
          >
            {isMarkSectionVisible ? "Hide Mark Section" : "Show Mark Section"}
          </Button>

          {/* Conditional rendering of Insert Mark section */}
          {isMarkSectionVisible && (
            <Box mb={2} sx={{ borderTopWidth: "1px", padding: "15px 20px" }}>
              <Box>
                <label>Insert Mark</label>
                <input
                  className="border border-black outline-none py-2 px-3 rounded"
                  placeholder="Enter marks"
                  value={totalMarks}
                  type="number"
                  onChange={(e) => setTotalMarks(parseInt(e.target.value))}
                  onKeyDown={handleKeyDown}
                />

                <Box mt={2}>
                  <Stack flexDirection="row" alignItems="center" gap={2}>
                    <FormControlLabel
                      label="Mark Pass"
                      control={
                        <Radio
                          checked={marked === "pass"}
                          onChange={() => handleRadioChange("pass")}
                        />
                      }
                    />
                    <FormControlLabel
                      label="Mark Fail"
                      control={
                        <Radio
                          checked={marked === "fail"}
                          onChange={() => handleRadioChange("fail")}
                        />
                      }
                    />
                  </Stack>
                </Box>
              </Box>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickSecondOpen} variant="outlined">
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={secondDialogOpen}
        onClose={handleSecondClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {`Marks ${totalMarks} and status ${marked} cannot be changed, so please only submit if you are certain.`}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleSecondClose}>Cancel</Button>
          <Button onClick={sendSubjectiveGrade} autoFocus>
            {loading && (
              <CircularProgress
                style={{ width: "22px", height: "22px", marginLeft: "5px" }}
                color="inherit"
              />
            )}
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

